import Loading from "../../../components/Common/Loading";

import {
    useDeletePrefabV2DSMutation,
    useGetPrefabsListV2DSQuery,
    useGetPrefabsInfosV2DSQuery,
    useUpdatePrefabV2DSMutation
} from "../../../core/api/ds-prefab-api";
import {useCreateStateV2DSMutation} from "../../../core/api/ds-state-api";
import Prefabs from "../Prefabs";
import {useState} from "react";

function PrefabsDS(props) {

    const [updateUserState, updateUserStateResponse] = useCreateStateV2DSMutation();
    const [updatePrefab, updatePrefabResponse] = useUpdatePrefabV2DSMutation();
    const [deletePrefab, deletePrefabResponse] = useDeletePrefabV2DSMutation();
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
        isFetching
    } = useGetPrefabsInfosV2DSQuery();

    const [selectedPrefab, setSelectedPrefab] = useState("")

    return (
        <>
            <Loading
                isLoading={isLoading}
                isError={isError}
                error={error}
                isSuccess={isSuccess}
            >
                <Prefabs prefabsListReady={isSuccess}
                         prefabsList={data}
                         updateUserState={updateUserState}
                         updateUserStateResponse={updateUserStateResponse}
                         updatePrefab={updatePrefab}
                         updatePrefabResponse={updatePrefabResponse}
                         deletePrefab={deletePrefab}
                         deletePrefabResponse={deletePrefabResponse}
                         refetch={refetch}
                         game={props.game}
                         setSelectedPrefab={setSelectedPrefab}
                >
                </Prefabs>
            </Loading>

        </>
    );

}

export default PrefabsDS;
